import * as React from 'react';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { Qualtrics } from '@shared-ui/customer-qualtrics';

export const QualtricsForExperiments = (experimentName: string) => (
  <Experiment name={experimentName}>
    <ExperimentControl />
    <ExperimentVariant bucket={1}>
      <Qualtrics />
    </ExperimentVariant>
    <ExperimentVariant bucket={2}>
      <Qualtrics />
    </ExperimentVariant>
  </Experiment>
);
